import { gql } from "@/services/httpAdapter";

/**
 * Subscription for updates to a specific commission cycle.
 *
 * @param returnFields - dynamic fields to return from the subscription.
 *
 * @example
 * const returnFields = `
 *   title
 *   status
 *   dataUpdatedAt
 *   payPeriods {
 *     _id
 *     title
 *     status
 *     positionStatus {
 *       position
 *       status
 *     }
 *   }
 * `;
 */
export const onUpdateCommissionCycleQuery = (returnFields: string = "") => gql`
	subscription onUpdateCommissionCycle($_id: String) {
		onUpdateCommissionCycle(_id: $_id) {
			_id
			${returnFields}
		}
	}
`;

export const onUpdateCommissionCycleStatus = gql`
	subscription onUpdateCommissionCycleStatus($locationId: String, $commissionCycleId: String) {
		onUpdateCommissionCycleStatus(locationId: $locationId, commissionCycleId: $commissionCycleId) {
			locationId
			commissionCycleId
			status
			updatedCommissionCycle {
				_id
				title
				status
				startDate
				endDate
				dataUpdatedAt
				payPeriods {
					_id
					title
					intervalCode
					startDate
					endDate
					inReview
					drawIngested
					nextCCId
					previousCCId
					status
					positionStatus {
						position
						status
					}
					payPeriodProviders {
						status
						providerPayPeriodId
					}
				}
			}
		}
	}
`;
